<template>
    <div id="toapp">
        <div class="img">
            <a href="http://static.yuread.cn/upload/appinstall/appstore/pubread_for_quick.apk" @click="tip">立即领取</a>
        </div>
        <div class="tip">
            <div class="l"></div>
            <div class="r"></div>
            <h1>活动规则</h1>
            <p>1. 手机号登录并绑定本应用用户即可直接参与；未绑定手机号用户需绑定完成后参与。</p>
            <p>2. 完成手机号绑定的用户，点击“立即领取”下载小说应用“众创众阅”，安装成功后使用绑定手机号登录即可领取福利。</p>
            <p>3. 连续登录下载的“众创众阅”小说应用，可累计领取书币福利，最高可得8888书币。</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Toapp",

        methods : {
            tip(){
                alert("下载完成后，请下拉通知栏点击安装");
            }
        },
        created() {
            document.title = "畅读豪礼";
        }
    }
</script>

<style lang="less">
#toapp{
    .img{width:100%;height:1346px;background-image: url("http://static.yuread.cn/quick/toapp.jpg");background-repeat: no-repeat;background-size: 100% 100%;padding-top: 1114px;
        a{font-size:68px;line-height:136px;font-weight:800;display:block;margin:0 auto;text-align:center;color:#1b1918;width: 616px;height: 136px;background: linear-gradient(84deg, #FCA52D 0%, #F8C660 100%);box-shadow: 0px 4px 20px 0px rgba(250, 183, 72, 0.57);border-radius: 68px;}
    }
    .tip{background: #1B1918; position: relative;padding: 30px 50px 80px;
        .r{background: linear-gradient(85deg, #827B56, #1b1918);width: 162px;height: 4px;position:absolute;top:56px;right:100px;}
        .l{background: linear-gradient(85deg, #1b1918, #827B56);width: 162px;height: 4px;position:absolute;top:56px;left:100px;}
        h1{font-size: 40px;font-weight: 800;color: #F1D898;line-height: 58px;text-align: center;text-align: center;}
        p{font-size: 28px;color: #f1d898;line-height: 60px;}
    }
}
</style>
